import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, delayStep = 0.12, startDelay = 0.15 }) => (
  <>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: startDelay + i * delayStep, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </>
);

export const Eyebrow = ({ children, className = "", ...rest }) => (
  <p
    className={`font-mono text-xs uppercase tracking-[0.3em] text-coral-600 ${className}`}
    {...rest}
  >
    {children}
  </p>
);
